import '../App.css';
import React, { useState, useEffect } from 'react';
import { RiArrowDropRightLine } from 'react-icons/ri';
import { useApolloClient } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { PAGES } from '../constants/Pages';
import { MESSAGE } from '../constants/Message';
import Header from './Header';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import { GET_LOGISTIC_FORWARDER } from '../graphqlDefs/freights/mutations';
import { useQuery } from '@apollo/client';
import { logisticMaterialsDataQry } from '../gql/logisticMaterialsDataQry';
import { qualityGroupsDataQry } from '../gql/qualityGroupsDataQuery';
import { getMessage } from '../translations';

function FreightScreen() {
  const [showLogisticForworderSelectionPopup, setShowLogisticForworderSelectionPopup] = useState(false);
  const [logisticForworderData, setLogisticForworderData] = useState('');
  const [logisticForwardersDropdownData, setLogisticForwardersDropdownData] = useState([]);
  const [logisticMaterialsData, setLogisticMaterialsData] = useState('');
  const [logisticMaterialsDropdownData, setLogisticMaterialsDropdownData] = useState([]);
  const [qualityGroupsData, setQualityGroupsData] = useState('');
  const [qualityGroupDropdownData, setQualityGroupDropdownData] = useState([]);
  const [showValidationMessage, setShowValidationMessage] = useState(false); 
  const [validityMonth, setValidityMonth] = useState('');
  const [incoTerm, setIncoTerm] = useState('');
  const navigate = useNavigate();
  const logisticMaterialData = useQuery(logisticMaterialsDataQry);
  const qualityGroupData = useQuery(qualityGroupsDataQry);
  
  const filteredProvidersVariables = {
    filters: { type: "FORWARDER" },
    searchText: null,
  };
  
  const { loading, error, data, refetch } = useQuery(GET_LOGISTIC_FORWARDER, {
    variables: { input: filteredProvidersVariables },
  });

  useEffect(() => {
    if (logisticMaterialData.data?.logisticMaterials) {
      const logisticMaterialsNames = logisticMaterialData.data.logisticMaterials.map((logF) => ({
        label: logF.value,
        value: logF.value,
      }));
      setLogisticMaterialsDropdownData(logisticMaterialsNames);
    }
  }, [logisticMaterialData]);

  useEffect(() => {
    if (qualityGroupData.data?.qualityGroups) {
      const qualityGroupNames = qualityGroupData.data.qualityGroups.map((logF) => ({
        label: logF.value,
        value: logF.value,
      }));
      setQualityGroupDropdownData(qualityGroupNames);
    }
  }, [qualityGroupData]);

  useEffect(() => {
    refetch(); 
  }, [refetch]);

  useEffect(() => {
    if (!loading && data) {
      const logisticForwNames = data.filteredProviders.map((logF) => ({
        label: logF.value,
        value: logF.value,
      }));
      setLogisticForwardersDropdownData(logisticForwNames);
    }
  }, [loading, data]);
  const [selectedOption, setSelectedOption] = useState('');
  const handleDropdownChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleGoButtonClick = (e) => {
    e.preventDefault();
    if(selectedOption === 'logistic')
    {
      if (!logisticForworderData || !validityMonth || !logisticMaterialsData || !qualityGroupsData || !incoTerm) {
        setShowValidationMessage(true);
      } else {
        navigate(`/${PAGES.FREIGHTAPP}/${logisticForworderData}&${validityMonth}
        &${logisticMaterialsData}&${qualityGroupsData}&${incoTerm}`);
      }
    }
    else
    {
      if (!validityMonth || !logisticMaterialsData || !qualityGroupsData || !incoTerm) {
        setShowValidationMessage(true);
      } else {
        navigate(`/${PAGES.FREIGHTAPP}/${'dashVal'}&${validityMonth}
        &${logisticMaterialsData}&${qualityGroupsData}&${incoTerm}`);
      }
    }  
  };
  const startImport = () => {
    // also update the state value when popup opens
    refetch(); 
  };

  return (
    <>
      <body>
        <Header />
        <section id='deliveries-section' className='active'>
          <div id='container12' className='container columns full screen'>
            <div className='wrapper'>
              <div
                className='main-inner'
                data-onvisible-trigger='1'
                data-reorder='1,0'
                data-reorder-breakpoint='medium'
                style={{ opacity: 1 }}
              >
                <div className='w-50'>
                  <div className='container12info'>
                    <h2 id='text29' className='style8'>
                      <span className='p'>{getMessage('FREIGHT_IMPORT')}</span>
                    </h2>
                    <ul
                      id='buttons24'
                      className='style1 buttons'
                      style={{ opacity: 1 }}
                    >
                      <li>
                        <button
                          className='QuantityAddBtn button n01'
                          onClick={() => {
                            setShowLogisticForworderSelectionPopup(true);
                            startImport(); 
                          }}
                        >
                          <RiArrowDropRightLine className='startIcon' /> {getMessage('START_IMPORT')}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='w-40'>
                  <div id='image06' className='image full'>
                    <span className='frame deferred'>
                      <img
                        src='https://julesai.com/assets/images/image06.png'
                        data-src='done'
                        alt=''
                        style={{ opacity: 1 }}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </body>
      {showLogisticForworderSelectionPopup ? (
        <div className='overlay-box'>
          <div className='popup'>
            <a
              className='close'
              onClick={() => {
                setShowLogisticForworderSelectionPopup(false);
              }}
            >
              <svg
                className='sc-gsnTZi GjRDn MuiSvgIcon-root MuiSvgIcon-fontSizeMedium' focusable='false' 
                viewBox='0 0 24 24' aria-hidden='true' data-testid='CloseIcon'>
                <path
                  d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 
                6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'>
                </path>
              </svg>
            </a>
            <div className='content'>
              <form id='simpleForm'>
                <div className='AddCategoryBody'>
                  <h4>{getMessage('FREIGHT_POPUP')}</h4>
                  <FormControl className='FormField' sx={{ m: 1, minWidth: '47%' }} >
                    <Select
                      value={selectedOption}
                      onChange={handleDropdownChange}
                      required
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value={''}>{getMessage('LOGISTIC_FORWARDER_SHIPPING_LINE')}</MenuItem>
                      <MenuItem value={'logistic'}>{getMessage('LOGISTIC_FORWARDER_NAME')}</MenuItem>
                      <MenuItem value={'shipping'}>{getMessage('SHIPPING_LINE_NAME')}</MenuItem>
                    </Select>
                  </FormControl>
                  {selectedOption === 'logistic' && (
                    <FormControl className='FormField' sx={{ m: 1, minWidth: '47%' }}>
                      <Select
                        value={logisticForworderData}
                        onChange={(e) => setLogisticForworderData(e.target.value)}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                      >
                        <MenuItem disabled value="">
                          {getMessage('LOGISTIC_FORWARDER')}
                        </MenuItem>
                        {logisticForwardersDropdownData.map((listD) => (
                          <MenuItem key={listD.value} value={listD.value}>
                            {listD.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                  <FormControl className='FormField' sx={{ m: 1, minWidth: '47%' }} >
                    <Select
                      value={validityMonth}
                      onChange={(e) => setValidityMonth(e.target.value)}
                      required
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value={''}>{getMessage('Select validity month')}</MenuItem>
                      <MenuItem value={'1'}>January</MenuItem>
                      <MenuItem value={'2'}>February</MenuItem>
                      <MenuItem value={'3'}>March</MenuItem>
                      <MenuItem value={'4'}>April</MenuItem>
                      <MenuItem value={'5'}>May</MenuItem>
                      <MenuItem value={'6'}>June</MenuItem>
                      <MenuItem value={'7'}>July</MenuItem>
                      <MenuItem value={'8'}>August</MenuItem>
                      <MenuItem value={'9'}>September</MenuItem>
                      <MenuItem value={'10'}>October</MenuItem>
                      <MenuItem value={'11'}>November</MenuItem>
                      <MenuItem value={'12'}>December</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl className='FormField' sx={{ m: 1, minWidth: '47%' }} >
                    <Select
                      value={logisticMaterialsData}
                      onChange={(e) => setLogisticMaterialsData(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem disabled value="">
                        {getMessage('Select logistic material')}
                      </MenuItem>
                      {logisticMaterialsDropdownData.map((listD) => (
                        <MenuItem key={listD.value} value={listD.value}>
                          {listD.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl className='FormField' sx={{ m: 1, minWidth: '47%' }} >
                    <Select
                      value={qualityGroupsData}
                      onChange={(e) => setQualityGroupsData(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem disabled value="">
                        {getMessage('Select quality group')}
                      </MenuItem>
                      {qualityGroupDropdownData.map((listD) => (
                        <MenuItem key={listD.value} value={listD.value}>
                          {listD.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl className='FormField' sx={{ m: 1, minWidth: '47%' }} >
                    <Select
                      value={incoTerm}
                      onChange={(e) => setIncoTerm(e.target.value)}
                      required
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value={''}>{getMessage('Select incoterm')}</MenuItem>
                      <MenuItem value={'CIF'}>CIF</MenuItem>
                      <MenuItem value={'CFR'}>CFR</MenuItem>
                    </Select>
                  </FormControl>
                  <div className='validationMsg'>
                    {showValidationMessage && (!logisticForworderData || !logisticMaterialsData 
                    || !validityMonth || !qualityGroupsData || !incoTerm) && (
                      <p className='errorMsg'>{getMessage('POPUP_LOADING_VALIDATION')}</p>
                    )}
                  </div>
                  <div className='btnSection'>
                    <Button variant="contained" onClick={handleGoButtonClick}>{getMessage('GO')}</Button> 
                  </div>                  
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default FreightScreen;
